// extracted by mini-css-extract-plugin
export default {"supportTitle":"Support_supportTitle__HaV+P","supporttxt":"Support_supporttxt__YvdaK","supportLinks":"Support_supportLinks__iS2bU","supportsubtxt":"Support_supportsubtxt__7H0bz"};